export default __webpack_public_path__ + "static/media/logo-black-white.3909f6f5.png";